<template>
	<div>
		<div v-if="loading" style="height: 40vh; display: flex; align-items: center; justify-content: center">
			<div style="display: flex; flex-direction: column; align-items: center">
				<OrbitSpinner :size="55" color="#431266" />
				<br /><br />
				<center>{{ loadingMessage }}</center>
			</div>
		</div>

		<div v-show="!loading" style="width: 100%; margin: auto;padding-top:1em">
			<div id="dropin-container"></div>
			<input type="checkbox" v-model="savePaymentInfo" style="margin-right: 10px;margin-top:10px" />
			Save this payment info with our payment provider (secure) for future payments.
			<br>
			<div v-if="savePaymentInfo">
				<input type="checkbox" v-model="allowCharge" style="margin-right: 10px;margin-top:10px" />
				Allow us to charge this credit card automatically for future invoices.
			</div>
			<div style="display: flex; width: 100%; justify-content: center; margin-top: 30px">

				<button v-if="formLoaded" @click="submitForm" style="width: 70%">Pay Now</button>
			</div>
		</div>
	</div>
</template>
<script>
import { OrbitSpinner } from "epic-spinners";
import dropin from "braintree-web-drop-in";
export default {
	name: "Braintree",
	props: ["endpoint", "amount", 'invoiceNumber'],
	components: { OrbitSpinner },
	data() {
		return {
			loading: true,
			instance: null,
			formLoaded: false,
			showButton: true,
			loadingMessage: "Loading..Please Wait..",
			savePaymentInfo: true,
			allowCharge: false
		};
	},
	mounted() {
		axios
			.get(this.endpoint + "create_bt_token" + "?invoiceNumber=" + this.invoiceNumber)
			.then((response) => {
				let token = response.data.token;

				dropin
					.create({
						authorization: token,
						container: "#dropin-container",
						card: {
							cardholderName: {
								required: true,
							},
						},
						applePay: {
							displayName: "Eatology Limited",
							paymentRequest: {
								total: {
									label: "Eatology Limited",
									amount: this.amount,
								},
								// We recommend collecting billing address information, at minimum
								// billing postal code, and passing that billing postal code with all
								// Apple Pay transactions as a best practice.
								requiredBillingContactFields: ["postalAddress"],
							},
						},
						googlePay: {
							googlePayVersion: 2,
							merchantId: "BCR2DN6TVPCM72IS",
							transactionInfo: {
								totalPriceStatus: "FINAL",
								totalPrice: this.amount,
								currencyCode: "HKD",
							},
							allowedPaymentMethods: [
								{
									type: "CARD",
									parameters: {
										// We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
										billingAddressRequired: true,
										billingAddressParameters: {
											format: "FULL",
										},
									},
								},
							],
						},
					})
					.then((instance) => {
						this.loading = false;
						this.formLoaded = true;
						this.instance = instance;
						instance.on("paymentMethodRequestable", function (event) {
							if (event.type == "ApplePayCard") {
								this.submitForm();
							}
						}.bind(this));
					})
					.catch((error) => {
						console.log(error);
						alert("2 An error has occured, please try again");
					});
			})
			.catch((error) => {
				alert("1 An error has occured, please try again.");
			});
	},
	methods: {
		submitForm() {
			this.formLoaded = false;
			this.instance
				.requestPaymentMethod()
				.then((payload) => {
					this.$emit("nonceLoaded", payload, this.savePaymentInfo, this.allowCharge);
				})
				.catch((error) => {
					this.formLoaded = true;
				});
		},
	},
};
</script>
<style scoped>
button {
	background-color: #431266;
	color: white;
	padding-top: 8px;
	padding-bottom: 8px;
	text-align: center;

	border-radius: 20px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Braintree.vue